(() => {
  function mainPicker() {
    return document.querySelector('variant-picker[data-template-product-match="true"]')
      || document.querySelector('main variant-picker');
  }

  function selectedValue(picker) {
    if (!picker) return '';
    const checked = picker.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value || checked.getAttribute('aria-label') || '';
    const select = picker.querySelector('select');
    if (select) return select.value || select.selectedOptions?.[0]?.textContent?.trim() || '';
    return '';
  }

  function productTitle(picker, title) {
    const raw = picker?.dataset.productTitle || title?.dataset.meinuBaseTitle || title?.textContent || '';
    const clean = raw.trim();
    if (title && clean) title.dataset.meinuBaseTitle = clean;
    return clean;
  }

  function motifTitle(baseTitle) {
    return baseTitle
      .replace(/^Kissenbezug\s+/i, '')
      .replace(/^Dekokissen\s+/i, '')
      .replace(/\s+mit Füllung(?=\s*–|$)/i, '')
      .trim();
  }

  function findTitle() {
    return document.querySelector(
      'product-information h1, .product-information h1, main h1, .text-block--text_xrnftG h1'
    );
  }

  function findConfirmation() {
    const direct = document.querySelector('.text-block--meinu_variant_confirmation');
    if (direct) return direct;
    return Array.from(document.querySelectorAll('main .text-block, main [class*="text-block"]'))
      .find((element) => element.textContent?.includes('Ausgewählt:')) || null;
  }

  function updateFromValue(rawValue, picker = mainPicker()) {
    const value = String(rawValue || '').trim();
    const title = findTitle();
    const confirmation = findConfirmation();
    if (!title || !value) return;

    const baseTitle = productTitle(picker, title);
    const motif = motifTitle(baseTitle);
    const isCover = value.toLocaleLowerCase('de-DE').includes('kissenbezug');
    const hasFilling = value.toLocaleLowerCase('de-DE').includes('füllung');

    if (isCover) {
      title.textContent = `Kissenbezug ${motif}`;
    } else if (hasFilling) {
      title.textContent = motif.includes(' – ')
        ? `Dekokissen ${motif.replace(' – ', ' mit Füllung – ')}`
        : `Dekokissen ${motif} mit Füllung`;
    } else {
      return;
    }

    const spans = confirmation?.querySelectorAll('span') || [];
    if (isCover) {
      if (spans.length >= 2) {
        spans[0].textContent = 'Kissenbezug';
        spans[1].textContent = 'ohne Füllung';
      } else if (confirmation?.querySelector('p')) {
        confirmation.querySelector('p').innerHTML = '<strong>Ausgewählt: Kissenbezug</strong><br>ohne Füllung';
      }
    } else {
      if (spans.length >= 2) {
        spans[0].textContent = 'Kissen mit Füllung';
        spans[1].textContent = 'inklusive Innenkissen';
      } else if (confirmation?.querySelector('p')) {
        confirmation.querySelector('p').innerHTML = '<strong>Ausgewählt: Kissen mit Füllung</strong><br>inklusive Innenkissen';
      }
    }
  }

  function sync() {
    const picker = mainPicker();
    updateFromValue(selectedValue(picker), picker);
  }

  function syncAgain() {
    window.setTimeout(sync, 0);
    window.setTimeout(sync, 250);
    window.setTimeout(sync, 900);
  }

  function optionFromEvent(event) {
    if (!(event.target instanceof Element)) return null;
    const picker = event.target.closest('variant-picker');
    if (!picker || picker !== mainPicker()) return null;
    const input = event.target.matches('input, select')
      ? event.target
      : event.target.closest('label')?.querySelector('input');
    return { picker, value: input?.value || '' };
  }

  function start() {
    sync();
    syncAgain();
    const picker = mainPicker();
    if (picker) {
      new MutationObserver(sync).observe(picker, {
        attributes: true,
        subtree: true,
        attributeFilter: ['checked', 'data-current-checked', 'data-variant-id']
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('click', (event) => {
    const option = optionFromEvent(event);
    if (!option) return;
    updateFromValue(option.value, option.picker);
    syncAgain();
  }, true);

  document.addEventListener('change', (event) => {
    const option = optionFromEvent(event);
    if (!option) return;
    updateFromValue(option.value, option.picker);
    syncAgain();
  }, true);

  document.addEventListener('shopify:product:select', syncAgain, true);
  window.addEventListener('pageshow', syncAgain);
  window.addEventListener('popstate', syncAgain);
})();
